/**
 * Lightweight profanity filter for user-generated content.
 * Designed to comply with App Store safety guidelines.
 */

// Basic list of common profanity. 
// For a production app, this should be expanded or a professional library used.
const BAD_WORDS = [
  'fuck', 'shit', 'asshole', 'bitch', 'cunt', 'dick', 'pussy', 'faggot', 
  'nigger', 'retard', 'whore', 'bastard', 'slut', 'damn', 'piss', 'cock'
];

/**
 * Filters profanity from a string, replacing bad words with asterisks.
 */
export function filterProfanity(text: string): string {
  if (!text) return text;
  
  let filteredText = text;
  
  BAD_WORDS.forEach(word => {
    // Case-insensitive regex with word boundaries to match exact words
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    filteredText = filteredText.replace(regex, (match) => {
      return match[0] + '*'.repeat(match.length - 1);
    });
  });
  
  return filteredText;
}

/**
 * Checks if a string contains profanity.
 */
export function containsProfanity(text: string): boolean {
  if (!text) return false;
  
  return BAD_WORDS.some(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    return regex.test(text);
  });
}
